import { Tooltip, Typography } from "@mui/material";

const EllipsisTypography = ({
  title,
  lineClamp = 1,
  ...rest
}) => {
  return (
    <Tooltip title={title} >
    <Typography
      {...rest}
      sx={{
        wordBreak: "break-word",
        display: "-webkit-box",
        WebkitLineClamp: lineClamp,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 'max-content',
        ...rest.sx
      }}
    >
      {title}
    </Typography>
    </Tooltip>
  );
};

export default EllipsisTypography;
